export default __webpack_public_path__ + "pdf/Sarah_Marzi.32dd86a.pdf";